import { facebookLandingRoutes } from 'site-modules/brand-landing/routes/facebook-landing';
import { kiaNewsLandingRoutes } from 'site-modules/brand-landing/routes/kia-news-landing';
import { kiaAltFuelShowroomRoutes } from 'site-modules/brand-landing/routes/kia-alt-fuel-showroom';
import { partnerCarInsuranceLandingRoutes } from 'site-modules/brand-landing/routes/partner-car-insurance-landing';

export const routes = Array.prototype.concat(
  facebookLandingRoutes,
  kiaNewsLandingRoutes,
  kiaAltFuelShowroomRoutes,
  partnerCarInsuranceLandingRoutes
);
